<agm-map [style.width]="width" [style.height]="height" [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" (mapReady)="mapReady($event)"></agm-map>
